import React, { useState } from 'react';
import { MyModal } from 'components/Atoms';
import FormNewCard from './components/FormNewCard';
import './styles.scss';

const ModalNewCard = ({ visible, onClose }) => {
  const [errorMsg, setErrorMsg] = useState({});
  const [nickName, setNickname] = useState('');
  // const elements = useElements();

  const handleClose = () => {
    // elements.getElement(CardNumberElement).clear();
    // elements.getElement(CardExpiryElement).clear();
    // elements.getElement(CardCvcElement).clear();
    setErrorMsg({});
    setNickname('');
    onClose();
  };

  return (
    <MyModal
      width={400}
      title="New Card"
      visible={visible}
      onClose={handleClose}
      footer={null}
      destroyOnClose={false}
      zIndex={1001}
      forceRender
    >
      {/* <FormNewCard
        onClose={handleClose}
        errorMsg={errorMsg}
        setErrorMsg={setErrorMsg}
        nickName={nickName}
        setNickname={setNickname}
      /> */}
    </MyModal>
  );
};

export default ModalNewCard;
